import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface IConnectionErrorReport {
  userId?: string | number | null;
  userEmail?: string | null;
  route?: string;
  requestUrl?: string;
  requestMethod?: string;
  status?: number;
  statusText?: string;
  errorMessage?: string;
}

/**
 * Reporta errores de conexión a un servicio externo (fuera de admin.sismat.com.ar),
 * para no depender del mismo backend que puede estar fallando.
 *
 * Usa HttpBackend (no HttpClient) a propósito: evita pasar por AuthInterceptor
 * (withCredentials, XSRF header, re-captura en Sentry) ya que este request va a
 * un dominio totalmente distinto y no debe llevar cookies/credenciales de sesión.
 */
@Injectable({ providedIn: 'root' })
export class ErrorReportingService {
  private http: HttpClient;

  constructor(handler: HttpBackend) {
    this.http = new HttpClient(handler);
  }

  report(data: IConnectionErrorReport): void {
    if (!environment.errorReportingUrl) {
      return;
    }

    const payload = {
      ...data,
      userAgent: navigator.userAgent,
      appVersion: environment.sentry?.release || null,
      clientTimestamp: new Date().toISOString()
    };

    const headers = new HttpHeaders().set('X-Api-Key', environment.errorReportingApiKey || '');

    this.http.post(environment.errorReportingUrl, payload, { headers }).subscribe({
      error: () => {
        // Fire-and-forget: si falla el reporte de error, no hay nada más que hacer acá.
      }
    });
  }
}
